import { create } from 'zustand';

interface OrderTypeState {
  orderType: OrderTypeEnum;
  setOrderType: (value: OrderTypeEnum) => void;
  resetOrderType: () => void;
}

export enum OrderTypeEnum {
  NORMAL = 'DEFAULT',
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
}

/**
 * Store for managing the orderType state across components
 */
const useOrderTypeStore = create<OrderTypeState>((set) => ({
  orderType: OrderTypeEnum.NORMAL,
  setOrderType: (value) => set({ orderType: value }),
  resetOrderType: () => set({ orderType: OrderTypeEnum.NORMAL }),
}));

export default useOrderTypeStore;
